import { Text, Heading, Img } from "../../components";
import React from "react";

export default function AboutUsSection() {
  return (
    <>
      {/* about us section */}
      <div className="flex flex-col items-center self-stretch pt-[30px]">
        <div className="container-xs flex flex-col gap-[202px] md:gap-[151px] md:px-10 sm:gap-[101px] sm:px-5">
          <div className="mr-2.5 flex flex-col items-center gap-3.5 md:mr-0">
            <Heading
              size="heading7xl"
              as="h1"
              className="text-[24px] font-bold uppercase tracking-[2.40px] text-amber-800_01 md:text-[22px]"
            >
              ABOUT US
            </Heading>
            <Heading
              as="h2"
              className="self-stretch text-center text-[46px] font-bold leading-[58px] text-color_style-01_neutrals-grey800 md:text-[42px] sm:text-[36px]"
            >
              Zwilling Labs is a leading digital twin solutions company for the manufacturing sector.
            </Heading>
          </div>

          {/* Image and Text Section */}
          <div className="mr-2.5 flex flex-col items-center gap-8 md:mr-0 md:flex-row md:gap-8 md:items-stretch">
            {/* Image */}
            <Img
              src="images/img_portrait_male_e.webp"
              alt="Profile Image"
              className="h-full w-[50%] rounded-[22px] object-contain md:w-[40%] sm:w-full"
            />

            {/* Text Content */}
            <div className="flex flex-1 flex-col items-start gap-5 md:self-stretch md:w-[55%] md:h-full">
              <Heading
                size="headings_h3"
                as="h3"
                className="font-dmsans text-[24px] font-bold text-color_style-02_primary_blue-blue600 md:text-[22px]"
              >
                Background
              </Heading>
              <Text
                as="p"
                className="w-full font-dmsans text-[14px] font-normal leading-[30px] text-color_style-01_neutrals-grey800"
              >
                <span className="flex-grow">
                  We enable manufacturing business owners, their management and customers by providing better, real-time
                  access and realistic experience of remote factory access and control. By monitoring and optimizing
                  processes, we help businesses achieve reduced water and energy consumption and carbon footprints.{" "}
                  <br />
                  <br />
                  Our advanced AI powered diagnostics help plant maintenance managers and monitoring teams in reducing
                  unplanned downtime by predicting and avoiding machine failure, mitigating operational and human risks,
                  and improving overall efficiency.
                  <br />
                  <br />
                  The Zwilling platform and underlying technology is based on innovative research and development
                  conducted for government and industry partners at IIT Bombay. We cater to diverse manufacturing
                  industries including steel, metals & mining, chemicals, pharmaceuticals, tyres, automotive and more.
                </span>
              </Text>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
